import React from "react";
import { contextapi } from "../helpers/contextapi";

const PageHeader = ({ title, subtitle, icon, action }) => {
  const context = React.useContext(contextapi);
  const { user } = context.values;
  const displayTitle = title || `Welcome ${user?.firstname || "Back"}`;

  document.title = `ATBCOE Kangere | ${displayTitle}`;

  return (
    <div className="flex items-center justify-between mb-6">
      <div className="flex items-center gap-3">
        {icon && (
          <div className="p-2.5 bg-primary-50 rounded-lg text-primary-600">
            {icon}
          </div>
        )}
        <div>
          <h1 className="text-xl font-bold text-neutral-900">{displayTitle}</h1>
          {subtitle && (
            <p className="text-sm text-neutral-500 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {action && <div>{action}</div>}
    </div>
  );
};

export default PageHeader;
